import { forwardRef } from 'react';
import type { IconBaseProps } from '../types.js';

export const AlligatorMascot = forwardRef<SVGSVGElement, IconBaseProps>(
  ({ className, size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 14.5C4 10.9 6.9 8 10.5 8H14.8C17.7 8 20 10.3 20 13.2V14.3C20 16.9 17.9 19 15.3 19H9.8C6.6 19 4 16.4 4 13.2V14.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.2 11.4H17.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="12.2" cy="12.2" r="0.9" fill="currentColor" />
      <path d="M7.4 15.7H13.7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  ),
);

AlligatorMascot.displayName = 'alligator-mascot';
